import {
  Button,
  Checkbox,
  Form,
  Input,
  InputNumber,
  Row,
  Col,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import { getData } from "../../repository/api";

const { Option } = Select;

const auth = JSON.parse(localStorage.getItem("auth"));
const org = auth?.org;

const GeneralInformation = ({ form }) => {
  const [productCategories, setProductCategories] = useState([]);
  const [taxes, setTaxes] = useState([]);

  useEffect(() => {
    fetchProductCategories();
    fetchTaxes();
  }, []);

  const fetchTaxes = async () => {
    try {
      const response = await getData(`/GetTax/`);
      const mapped = response.map((item) => ({
        name: item.TaxName,
        value: item.id,
      }));
      setTaxes(mapped);
    } catch (error) {
      console.error("Error fetching taxes:", error);
    }
  };

  const fetchProductCategories = async () => {
    try {
      const response = await getData(`/GetProductCategories/`);
      const mapped = response.map((item) => ({
        name: item.CategoryName,
        value: item.id,
      }));
      setProductCategories(mapped);
    } catch (error) {
      console.error("Error fetching product categories:", error);
    }
  };

  const generateBarcode = () => {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 1000);
    const newBarcode = `BC${timestamp}${random}`;
    form.setFieldsValue({ BarCode: newBarcode });
  };

  return (
    <div className="col-12">
      <Row gutter={16}>
        {/* Category & Type */}
        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            label="Product Category"
            name="ProductCategories"
            rules={[
              { required: true, message: "Select at least one category" },
            ]}
          >
            <Select placeholder="Select categories">
              {productCategories.map((cat) => (
                <Option key={cat.value} value={cat.value}>
                  {cat.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            label="Product Type"
            name="ProductType"
            rules={[{ required: true, message: "Please select product type" }]}
          >
            <Select placeholder="Select product type">
              <Option value="Consumable">Consumable</Option>
              <Option value="Service">Service</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            label="Customer Taxes"
            name="CustomerTaxes"
            rules={[
              { required: true, message: "Please select customer taxes" },
            ]}
          >
            <Select placeholder="Select customer taxes">
              {taxes.map((tax) => (
                <Option key={tax.value} value={tax.value}>
                  {tax.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            label="Vendor Taxes"
            name="VendorTaxes"
            rules={[{ required: true, message: "Please select vendor taxes" }]}
          >
            <Select placeholder="Select vendor taxes">
              {taxes.map((tax) => (
                <Option key={tax.value} value={tax.value}>
                  {tax.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        {/* Pricing */}
        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            label="Sales Price"
            name="SalesPrice"
            rules={[
              { required: true, message: "Please enter sales price" },
              { type: "number", min: 0, message: "Price must be >= 0" },
            ]}
          >
            <InputNumber
              min={0}
              style={{ width: "100%" }}
              formatter={(value) =>
                `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            label="Cost"
            name="Cost"
            rules={[
              { required: true, message: "Please enter cost" },
              { type: "number", min: 0, message: "Cost must be >= 0" },
            ]}
          >
            <InputNumber
              min={0}
              style={{ width: "100%" }}
              formatter={(value) =>
                `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            label="Discount"
            name="Discount"
            rules={[
              { required: true, message: "Please enter discount" },
              { type: "number", min: 0, max: 100, message: "0 - 100 only" },
            ]}
          >
            <InputNumber
              min={0}
              max={100}
              style={{ width: "100%" }}
              formatter={(value) => `${value}%`}
              parser={(value) => value.replace(/%\s?|(,*)/g, "")}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            label="Quantity"
            name="Quantity"
            rules={[
              { required: true, message: "Please enter quantity" },
              { type: "number", min: 0, message: "Quantity must be >= 0" },
            ]}
          >
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        {/* HSN/SAC Info */}
        <Col xs={24} sm={12} lg={8}>
          <Form.Item label="HSN/SAC Code" name="HSN_SAC_Code">
            <Input placeholder="Enter HSN/SAC code" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Form.Item label="HSN/SAC Description" name="HSN_SAC_Description">
            <Input placeholder="Enter HSN/SAC description" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} lg={8} className="d-flex align-items-center gap-2">
          <Form.Item
            label="Barcode"
            name="BarCode"
            rules={[{ required: true, message: "Please enter barcode" }]}
          >
            <Input placeholder="Enter Barcode" />
          </Form.Item>
          <Button onClick={generateBarcode}>Generate</Button>
        </Col>

        {/* Checkboxes */}
        <Col xs={12} sm={8} lg={4}>
          <Form.Item
            name="CanBeSold"
            valuePropName="checked"
            /* rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject("Please check this box"),
              },
            ]} */
          >
            <Checkbox>Can Be Sold</Checkbox>
          </Form.Item>
        </Col>

        <Col xs={12} sm={8} lg={4}>
          <Form.Item
            name="CanBePurchased"
            valuePropName="checked"
            /* rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject("Please check this box"),
              },
            ]} */
          >
            <Checkbox>Can Be Purchased</Checkbox>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            label="Internal Reference"
            name="InternalReference"
            /*  rules={[
              { required: true, message: "Please enter internal reference" },
            ]} */
          >
            <Input placeholder="Enter internal reference" />
          </Form.Item>
        </Col>

        <Col xs={24} lg={16}>
          <Form.Item
            label="Internal Notes"
            name="InternalNotes"
            /* rules={[{ required: true, message: "Please enter internal notes" }]} */
          >
            <Input.TextArea rows={3} placeholder="Enter internal notes" />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default GeneralInformation;
